export default __webpack_public_path__ + "static/media/DEBoK_Words.cbceffb0.png";